import React from "react";

const BellStrongIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.5 10.25V8.25C15.5 5.3505 13.1495 3 10.25 3C7.35051 3 5 5.35051 5 8.25L5 10.25L3 14.5L17.5 14.5L15.5 10.25Z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.25 15C7.25 15 7.25 17.5 10.25 17.5C13.25 17.5 13.25 15 13.25 15",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(BellStrongIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;